import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { FaSearchPlus, FaArrowRight } from 'react-icons/fa';

const COLORS = {
  primary: "#F15A24",
  primaryLight: "#FF7A45",
  secondary: "#FFC20E",
  secondaryLight: "#FFD95E",
  lightGray: "#F8F8F8",
  darkGray: "#2D2D2D",
  white: "#FFFFFF",
  black: "#000000"
};

const API_URL = import.meta.env.VITE_API_URL;

const Gallery = () => {
  const [gallery, setGallery] = useState({
    title: "Our Gallery",
    subtitle: "Stunning collection of images",
    items: Array(12).fill({
      image: "",
      subtitle: "",
      title: "",
      description: "",
    }),
  });
  const [selectedImage, setSelectedImage] = useState(null);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    fetch(`${API_URL}/gallery`)
      .then((res) => res.json())
      .then((data) => {
        setGallery(data);
      });
  }, []);

  const openModal = (item) => {
    setSelectedImage(item);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  // Filter categories (you might want to get these from your API)

  return (
    <div className="min-h-screen" 
    style={{ 
      backgroundColor: COLORS.lightGray,
      backgroundColor: COLORS.lightGray,
      paddingTop: "80px",
      minHeight: "calc(100vh - 80px)"
    }}
    >
      {/* Hero Section */}
      <div 
        className="w-full py-20 px-8 text-center relative overflow-hidden"
        style={{ backgroundColor: COLORS.primary }}
      >
        <div className="absolute inset-0 z-0 opacity-20">
          <img 
            src="https://images.unsplash.com/photo-1492684223066-81342ee5ff30?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80" 
            alt="Gallery background"
            className="w-full h-full object-cover"
          />
        </div>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="relative z-10"
        >
          <h1 className="text-4xl font-bold text-white mb-4">
            {gallery.title}
          </h1>
          <p className="text-xl text-white max-w-2xl mx-auto">
            {gallery.subtitle}
          </p>
        </motion.div>
      </div>

      {/* Main Content */}
      <div className="py-16 px-8">
        <div className="max-w-7xl mx-auto">
 

          {/* Gallery Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {gallery.items.map((item, index) => (
              <motion.div 
                key={index}
                whileHover={{ scale: 1.03 }}
                className="relative group overflow-hidden rounded-xl shadow-lg"
              >
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-64 object-cover transition-transform duration-500 group-hover:scale-110"
                />
                
                {/* Overlay */}
                <div 
                  className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-6"
                  onClick={() => openModal(item)}
                >
                  <div className="transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                    <h3 className="text-xl font-bold text-white mb-1">{item.title}</h3>
                    <p className="text-sm text-gray-200 mb-3">{item.subtitle}</p>
                    <div className="flex items-center text-white">
                      <FaSearchPlus className="mr-2" />
                      <span className="text-sm">View Details</span>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          {/* Call to Action */}
          <div className="mt-16 text-center">
            <motion.a
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              href="#"
              className="inline-flex items-center px-8 py-4 rounded-lg font-bold"
              style={{ 
                backgroundColor: COLORS.secondary,
                color: COLORS.darkGray
              }}
            >
              View More Galleries
              <FaArrowRight className="ml-3" />
            </motion.a>
          </div>
        </div>
      </div>

      {/* Image Modal */}
      {selectedImage && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/90">
          <div className="relative max-w-4xl w-full bg-white rounded-xl overflow-hidden">
            <button 
              onClick={closeModal}
              className="absolute top-4 right-4 z-10 w-10 h-10 rounded-full flex items-center justify-center"
              style={{ backgroundColor: COLORS.primary, color: COLORS.white }}
            >
              &times;
            </button>
            
            <div className="md:flex">
              <div className="md:w-2/3 h-96">
                <img 
                  src={selectedImage.image} 
                  alt={selectedImage.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="md:w-1/3 p-6">
                <h2 className="text-2xl font-bold mb-2" style={{ color: COLORS.darkGray }}>
                  {selectedImage.title}
                </h2>
                <p className="text-sm mb-4" style={{ color: COLORS.primary }}>
                  {selectedImage.subtitle}
                </p>
                <p className="text-sm" style={{ color: COLORS.darkGray }}>
                  {selectedImage.description}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;